import React from 'react';
import AdBreakPopUpRedux from '../../../../containers/pluginSettings/AdRules/AdBreakPopUp';

function AdBreakSet(props) {
  const { onClick, btnClassName, labelText, adBreak, popupType, popupIndex, popupKey, isValid } =
    props;
  const btnClassNames = btnClassName ? `adBreakBtn ${btnClassName}` : 'adBreakBtn';
  const adBreakBtnClassName = isValid ? '' : 'adBreakBtnErrorText';
  const adBreakBtnClassLabel = isValid ? '' : 'adBreakBtnErrorLabel';
  const adBreakSetClassName = isValid ? 'adBreakSet' : 'adBreakSet adBreakSetErrorValidation';
  const adBreakValidationError = isValid ? { visibility: 'hidden' } : { visibility: 'visible' };

  return (
    <div className={adBreakSetClassName}>
      <div className={btnClassNames}>
        <div className={adBreakBtnClassName} onClick={onClick}>
          {adBreak && adBreak.instances !== 0 ? adBreak.instances : '+'}
        </div>
        <label className={adBreakBtnClassLabel}>{labelText}</label>
        <div
          className="validationError"
          style={adBreakValidationError && { display: isValid ? 'none' : 'table-column' }}
        ></div>
      </div>
      <AdBreakPopUpRedux index={popupIndex} key={popupKey} type={popupType} />
    </div>
  );
}

export default AdBreakSet;
